/*
 * Author: Duncan Levings
 * 
 * Copyright (c) 2020 DuncanLevings
 */

export default {
    RESUME: 1,
    RS_TOOLS: 2,
    BUDGET: 3
}